import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { DataExtractorProvider, useDataExtractorStore } from '../store';

const propTypes = {
  match: PropTypes.object,
}

const DataExtractorForm = withRouter(() => {
  const { collection: { useSubmit } } = useDataExtractorStore()
  const { handleSuccess, handleError } = useAppAlert()

  const handleSubmit = useSubmit()

  const handleCloseSidebar = useCallback(() => {
    history.push('/settings/data-extractors')
  }, [])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      handleCloseSidebar()
      handleSuccess('Success', `Data Extractor created.`)
    } catch {
      handleError('Error', 'Data Extractor was not saved.')
    }
  }, [handleSubmit, handleCloseSidebar, handleSuccess, handleError])

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: () => handleCloseSidebar() }}
    title='Create Data Extractor'
  >
    <Helmet title="Data Extractor" />
    <Form handleSubmit={handleSubmitAndClose} />
  </DefaultSheet>
})

DataExtractorForm.propTypes = propTypes

export default function DataExtractorFormLayout() {
  return <DataExtractorProvider>
    <DataExtractorForm />
  </DataExtractorProvider>
}

